import React, { useState } from "react";
import CodeEditor from "../kits/DesignKit/CodeEditor";

const LessonTabs = () => {
  const [activeTab, setActiveTab] = useState("konzept");

  const tabs = [
    { id: "konzept", label: "Konzept" },
    { id: "code", label: "Code" },
    { id: "tipp", label: "Tipp" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "konzept":
        return (
          <div className="p-4 text-sm">
            <p><strong>Idee:</strong> Wir nutzen ein flexibles Grid, um Kurskarten responsiv darzustellen.</p>
            <p className="text-gray-600 mt-2">
              Das schafft Ordnung und Lesbarkeit – egal ob Desktop oder mobil.
            </p>
          </div>
        );
      case "code":
        return (
          <CodeEditor filename="grid.jsx" language="jsx">
{`<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
  <Card />
  <Card />
  <Card />
</div>`}
          </CodeEditor>
        );
      case "tipp":
        return (
          <div className="p-4 text-sm">
            <p><strong>Hinweis:</strong> Für komplexe Layouts kannst du auch CSS Grid mit benannten Bereichen verwenden.</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 pt-24 pb-20">
      <div className="rounded-xl border border-black bg-white shadow-sm overflow-hidden">
        <div className="flex space-x-2 border-b border-black px-4 pt-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`text-sm font-mono py-1 px-3 border rounded-md transition-all duration-200
                ${activeTab === tab.id
                  ? "bg-black text-white border-black"
                  : "bg-white text-black border-transparent hover:border-black"}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="px-4 pb-6">{renderContent()}</div>
      </div>
    </div>
  );
};

export default LessonTabs;
